import type { RequestConfig } from '@customTypes/index';
import type { VideoItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetArtistProfileVideoListRequest = {
  profileId: string;
};

export type GetArtistProfileVideoListParams =
  RequestConfig<GetArtistProfileVideoListRequest>;

export const getArtistProfileVideoList = async ({
  params,
  config
}: GetArtistProfileVideoListParams) =>
  api.get<VideoItemDto[]>(`/api/videos/artist/${params.profileId}`, config);
